import { createContext } from '../utils/createContext';
export const defaultConfig = {
  strictMode: 'off'
};
export const [NativeBaseConfigProvider, useNativeBaseConfig] = createContext('NativeBaseConfigProvider');
//# sourceMappingURL=NativeBaseContext.js.map